module.exports = __webpack_public_path__ + "static/media/prod5.91f9dfec.jpeg";